import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";

/**
 * 值集 值集视图
 * @email WY <yang.wang06@hand-china.com>
 * @creationDate 2019/12/25
 * @copyright HAND ® 2019
 */
import request from "../../utils/request";
import { getEnvConfig } from "../../utils/iocUtils";
import { getCurrentOrganizationId, isTenantRoleLevel } from "../../utils/utils";
var _getEnvConfig = getEnvConfig(),
  HZERO_PLATFORM = _getEnvConfig.HZERO_PLATFORM;
/**
 * 统一查询独立、SQL、URL类型的值集
 * {HZERO_PLATFORM}/v1/lovs/data
 * @param {String} lovCode - 值集code
 * @param {Object} params - 额外的查询参数
 */

export function queryUnifyIdpValue(_x) {
  return _queryUnifyIdpValue.apply(this, arguments);
}
/**
 * 查询单个独立值集值
 * {HZERO_PLATFORM}/v1/lovs/value
 * @param {String} lovCode
 */

function _queryUnifyIdpValue() {
  _queryUnifyIdpValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(lovCode) {
    var params,
      publicMode,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            publicMode = _args.length > 2 ? _args[2] : undefined;
            return _context.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(
            // eslint-disable-next-line no-nested-ternary
            publicMode ? 'pub/' : isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lovs/data"), {
              query: _objectSpread({
                lovCode: lovCode
              }, params)
            }));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _queryUnifyIdpValue.apply(this, arguments);
}
export function queryIdpValue(_x2) {
  return _queryIdpValue.apply(this, arguments);
}
/**
 * 批量查询独立值集值
 * {HZERO_PLATFORM}/v1/lovs/value/batch
 * @param {Object} params
 * @example queryMapIdpValue({ level: 'HPFM.LEVEL', dir: 'HPFM.DIRECTION' })
 */

function _queryIdpValue() {
  _queryIdpValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(lovCode) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lovs/value"), {
              query: {
                lovCode: lovCode
              }
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _queryIdpValue.apply(this, arguments);
}
export function queryMapIdpValue(_x3) {
  return _queryMapIdpValue.apply(this, arguments);
} // 没有用到的 api 先注释
// /**
//  * 根据父值集值查询子值集值
//  * {HZERO_PLATFORM}/v1/lovs/value/parent-value
//  * @param {Object} params
//  * @param {String} params.lovCode 子值集编码
//  * @param {String} params.parentValue 父值集值
//  */
// export async function queryParentIdpValue(params) {
//   return request(`${HZERO_PLATFORM}/v1/lovs/value/parent-value`, {
//     query: params,
//   });
// }
// 没有用到的 api 先注释
// /**
//  * 根据 tag 获取值集值
//  * {HZERO_PLATFORM}/v1/lovs/value/tag
//  * @param {Object} params
//  * @param {String} params.lovCode 值集编码
//  * @param {String} params.tag tag
//  */
// export async function queryTagIdpValue(params) {
//   return request(`${HZERO_PLATFORM}/v1/lovs/value/tag`, {
//     query: params,
//   });
// }

/**
 * 查询lov最近选择记录
 * {HZERO_PLATFORM}/v1/lovs/value/batch
 * @param {Object} params
 */

function _queryMapIdpValue() {
  _queryMapIdpValue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
    var publicMode, otherParams;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            publicMode = params.publicMode, otherParams = _objectWithoutProperties(params, ["publicMode"]);
            return _context3.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(
            // eslint-disable-next-line no-nested-ternary
            publicMode ? 'pub/' : isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lovs/value/batch"), {
              query: otherParams
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _queryMapIdpValue.apply(this, arguments);
}
export function queryRecord(_x4) {
  return _queryRecord.apply(this, arguments);
}
/**
 * 查询lov最近选择记录
 * {HZERO_PLATFORM}/v1/lovs/value/batch
 * @param {Object} params
 */

function _queryRecord() {
  _queryRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lov-view/info/history"), {
              query: params
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _queryRecord.apply(this, arguments);
}
export function deleteRecord(_x5, _x6) {
  return _deleteRecord.apply(this, arguments);
}
function _deleteRecord() {
  _deleteRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params, viewCode) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", request("".concat(HZERO_PLATFORM, "/v1/").concat(isTenantRoleLevel() ? "".concat(getCurrentOrganizationId(), "/") : '', "lov-view/info/history"), {
              method: 'DELETE',
              body: params,
              query: viewCode
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _deleteRecord.apply(this, arguments);
}